import styled from 'styled-components';
import { WCS } from '../../week-utils';

export const DayHeaderSC = styled.div`
  width: 100%;
  height: ${WCS.dayHeaderHeight}px;
  position: sticky;
  top: 0;
  z-index: 10001;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  .day-name {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: rgba(24, 30, 53, 0.6);
    mix-blend-mode: normal;
  }

  .day-date {
    width: 35px;
    height: 35px;
    margin-top: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: rgba(24, 30, 53, 0.6);
    mix-blend-mode: normal;

    &.same {
      border-radius: 50%;
      background: #ff4496;
      color: white;
      font-weight: bold;
    }
  }

  .week-overlay-left,
  .week-overlay-right {
    top: 0;
    z-index: 99;
    position: absolute;
    width: ${WCS.timeLineWidth}px;
    height: ${WCS.dayHeaderHeight}px;

    .bar {
      position: sticky;
      width: ${WCS.timeLineWidth}px;
      height: ${WCS.dayHeaderHeight}px;
      background-color: white;
    }
  }

  .week-overlay-left {
    left: -100px;
  }

  .week-overlay-right {
    left: 100%;
  }
`;
